import React, { useRef } from 'react'
import { useEffect } from 'react'

type Props = Omit<React.HTMLProps<HTMLSelectElement>, 'onChange'> & {
  onChange?: (newValue: string) => void
}

export const Select: React.FC<Props> = (props) => {
  const ref = useRef<HTMLSelectElement>(null)

  // this is a bit ugly, and smells a bit, but I think it's the best way of integrating with the current codebase
  useEffect(() => {
    // initialize chosen
    if (ref.current !== null) {
      // yes, this is a bit strange: https://stackoverflow.com/questions/29790605/how-to-identify-that-chosen-plugin-initialized-on-element
      // const isInitialized = window.$(ref.current).data('chosen') === undefined
      // if (isInitialized) {
      //   return
      // }

      window.$(ref.current).chosen('destroy')

      window
        .$(ref.current)
        .chosen()
        .change(() => {
          if (props.onChange !== undefined) {
            props.onChange(ref.current!.options[ref.current!.selectedIndex].value)
          }
        })

      window
        .$(ref.current)
        .siblings('.chosen-container')
        .addClass('chosen--left')

      return () => {
        // destroying the chosen element is the correct way of handling the object, but for some reason, this breaks the positioning of the dropdown
        // let's blame it on legacy code, and hope that we don't run into issues with not destroying the element
        // window.$(ref.current).chosen('destroy')
      }
    }
  }, [])

  const { onChange, ...restProps } = props

  return (
    <select ref={ref} data-placeholder={props.placeholder} className="chosen-show chosen chosen--left" {...restProps} />
  )
}
